import { render, staticRenderFns } from "./PaymentIframePopup.vue?vue&type=template&id=3fc413b8&scoped=true"
import script from "./PaymentIframePopup.vue?vue&type=script&lang=js"
export * from "./PaymentIframePopup.vue?vue&type=script&lang=js"
import style0 from "./PaymentIframePopup.vue?vue&type=style&index=0&id=3fc413b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc413b8",
  null
  
)

export default component.exports